import moment, { type Moment } from 'moment';
import { TIME_ZONE } from 'src/constants/timezone';

export function momentDate(date: string, format = '') {
  return moment(date, format);
}

export function dateToTimeZone(date: Moment) {
  return date.tz(TIME_ZONE);
}

export function formatDate(date: string | Moment, format = 'DD.MM.YYYY') {
  return dateToTimeZone(moment(date)).format(format);
}

export function formatDateWithoutTimezone(date: string | Moment, format = 'YYYY-MM-DDTHH:mm:ss') {
  return dateToTimeZone(moment(date)).format(format);
}

export function formatMomentDate(date: Moment, format = 'DD.MM.YYYY') {
  return date.format(format);
}

export function dateToISO(date: Moment) {
  return date.toISOString();
}

export function isValidDate(date: Moment) {
  return date.isValid();
}

export function isDateInFuture(date: Moment) {
  return date?.isAfter(moment());
}

export function formatCountdown(countdownDuration: number, elapsedTime: number) {
  const duration = moment.duration(countdownDuration - elapsedTime, 'seconds');
  const minutes = Math.floor(duration.asMinutes());
  const seconds = duration.seconds().toString().length === 1 ? `0${duration.seconds().toString()}` : duration.seconds();

  return `${minutes}:${seconds}`;
}

// Whole seconds left until the given moment; at least one, so a countdown to it always completes
export function getCountdownDuration(until: number) {
  return Math.max(1, Math.ceil((until - Date.now()) / 1000));
}

// "1 хвилину", "2 хвилини", "5 хвилин", as in "через 5 хвилин"
export function formatMinutes(minutes: number) {
  const lastDigit = minutes % 10;
  const lastTwoDigits = minutes % 100;

  if (lastDigit === 1 && lastTwoDigits !== 11) return `${minutes} хвилину`;
  if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) {
    return `${minutes} хвилини`;
  }

  return `${minutes} хвилин`;
}

export function getLeaveApplicationDateDiff(dateFrom: Moment, dateTo: Moment) {
  return dateTo.diff(dateFrom, 'days') + 1;
}
